import { render } from "./LottieDemo.vue?vue&type=template&id=4ecbf521&scoped=true"
import script from "./LottieDemo.vue?vue&type=script&lang=js"
export * from "./LottieDemo.vue?vue&type=script&lang=js"

import "./LottieDemo.vue?vue&type=style&index=0&id=4ecbf521&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecbf521"]])

export default __exports__